import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'weekDay'
})
export class WeekDayPipe implements PipeTransform {
  translocoService = inject(TranslocoService);
  transform(value: number | undefined | null): string | null {
    switch (value) {
      case 0:
        return this.translocoService.translate('week_day.sun');
      case 1:
        return this.translocoService.translate('week_day.mon');
      case 2:
        return this.translocoService.translate('week_day.tue');
      case 3:
        return this.translocoService.translate('week_day.wed');
      case 4:
        return this.translocoService.translate('week_day.thu');
      case 5:
        return this.translocoService.translate('week_day.fri');
      case 6:
        return this.translocoService.translate('week_day.sat');
      default:
        return null;
    }
  }
}
